import { render, staticRenderFns } from "./FeatureGuide.vue?vue&type=template&id=3b2a44bf&scoped=true"
import script from "./FeatureGuide.vue?vue&type=script&lang=js"
export * from "./FeatureGuide.vue?vue&type=script&lang=js"
import style0 from "./FeatureGuide.vue?vue&type=style&index=0&id=3b2a44bf&prod&lang=scss&scoped=true"
import style1 from "./FeatureGuide.vue?vue&type=style&index=1&id=3b2a44bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a44bf",
  null
  
)

export default component.exports